import React, { useCallback, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { toast } from 'react-toastify';
import useStyles, {
  ContainerPrincipal,
  TitleTable,
} from './ClientesEmDebitoStyles';
import { GroupDefinitions } from '../../../components/NavBar/Dialog/DialogAlterarSenhaStyles';
import RadioField from '../../../components/UI/Field/Radio/RadioField';
import WrapperSubTitleForm from '../../../components/UI/WrapperSubTitleForm';
import { ButtonUI, SelectorField } from '../../../components';
import CheckboxField from '../../../components/UI/Field/Checkbox/CheckboxField';
import Dica from '../../../components/UI/Dica/Dica';
import SearchButtonWithLabel from '../../../components/UI/Button/Search/Label/SearchButtonWithLabel';
import { ClearButton } from '../../../components/AtualizarMuralDashboard/atualizarMuralDashboard.styles';
import LoadingUI from '../../../components/UI/Loading/LoadingUI';
import MoneyField from '../../../components/UI/Field/Money/MoneyField';
import {
  findClientesEmDebito, findUsuariosComerciaisAtivos, imprimirRelacaoDosClientesEmDebitoExcel, imprimirRelacaoDosClientesEmDebitoPdf,
} from '../../../services/core/analiseGerencial/analiseGerencial.service';
import SelectorModel from '../../../models/SelectorModel';
import TabelaClientesEmDebito from './TabelaClientesEmDebito';
import { downloadFileSispag, openPageFileBase64 } from '../../../helpers';


function ClientesEmDebitoComponent() {
  const styles = useStyles();

  const [todosComerciaisDefinition, setTodosComerciaisDefinition] = useState('0');
  const [statusClienteDefinition, setStatusClienteDefinition] = useState('A');
  const [comercialEspecifico, setComercialEspecifico] = useState(false);
  const [idUsuarioComercial, setIdUsuarioComercial] = useState('');
  const [usuariosComerciais, setUsuariosComerciais] = useState([]);
  const [debitosAcimaDe, setDebitosAcimaDe] = useState(0);
  const [selecionarDosDoisSistemas, setSelecionarDosDoisSistemas] = useState(true);
  const [content, setContent] = useState([]);
  const [loading, setLoading] = useState(false);

  const onChangeTodosComerciaisHandler = useCallback((event) => {
    const { value } = event.target;
    setTodosComerciaisDefinition(value);
    setComercialEspecifico(value === '1');
    if (value !== '1') {
      setIdUsuarioComercial('');
    }
  }, [setComercialEspecifico, setTodosComerciaisDefinition]);

  const onSubmitHandler = useCallback(() => {
    setLoading(true);
    setContent([]);

    findClientesEmDebito(todosComerciaisDefinition === '0', idUsuarioComercial, selecionarDosDoisSistemas, statusClienteDefinition, debitosAcimaDe)
      .then((response) => {
        setContent(response.data);
        if (response.data.length === 0) {
          toast.error('Nenhum resultado foi encontrado relacionado à sua pesquisa');
        } else {
          toast.success('Pesquisa realizada com sucesso!');
        }
      }).finally(() => {
        setLoading(false);
      });
  }, [todosComerciaisDefinition, idUsuarioComercial, selecionarDosDoisSistemas, statusClienteDefinition, debitosAcimaDe]);


  const onLimparHandler = useCallback(() => {
    setTodosComerciaisDefinition('0');
    setStatusClienteDefinition('A');
    setComercialEspecifico(false);
    setIdUsuarioComercial('');
    setDebitosAcimaDe(0);
    setSelecionarDosDoisSistemas(true);
    setContent([]);
  }, []);

  const onClickExportarExcel = useCallback(() => {
    setLoading(true);
    imprimirRelacaoDosClientesEmDebitoExcel(todosComerciaisDefinition === '0', idUsuarioComercial, selecionarDosDoisSistemas, statusClienteDefinition, debitosAcimaDe).then((response) => {
      if (response.data.length > 0) {
        downloadFileSispag(response.headers.filename, response.data);
      }
    }).catch(() => {
      toast.error('Erro ao gerar o Excel. Tente novamente mais tarde.');
    }).finally(() => {
      setLoading(false);
    });
  }, [todosComerciaisDefinition, idUsuarioComercial, selecionarDosDoisSistemas, statusClienteDefinition, debitosAcimaDe]);

  const onClickExportarPDF = useCallback(() => {
    setLoading(true);
    imprimirRelacaoDosClientesEmDebitoPdf(todosComerciaisDefinition === '0', idUsuarioComercial, selecionarDosDoisSistemas, statusClienteDefinition, debitosAcimaDe).then((response) => {
      if (response.data.length > 0) {
        openPageFileBase64(response.data, response.headers['content-type']);
      }
    }).catch(() => {
      toast.error('Erro ao gerar o PDF. Tente novamente mais tarde.');
    }).finally(() => {
      setLoading(false);
    });
  }, [todosComerciaisDefinition, idUsuarioComercial, selecionarDosDoisSistemas, statusClienteDefinition, debitosAcimaDe]);

  useEffect(() => {
    if (usuariosComerciais.length === 0) {
      findUsuariosComerciaisAtivos().then((response) => {
        const resposta = response.data.map(usuario => (new SelectorModel(usuario.idUsuario, usuario.nomeUsuario)));
        setUsuariosComerciais(resposta);
      });
    }
  }, [usuariosComerciais.length]);


  return (
    <ContainerPrincipal>
      <LoadingUI show={loading} />

      <div style={{ border: '1px solid', padding: '10px', width: '90%' }}>
        <WrapperSubTitleForm title="Opções de consulta">
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div style={{
              border: '1px solid', padding: '10px', marginLeft: '10px', width: '45%',
            }}
            >
              <GroupDefinitions
                aria-label="todosComerciais"
                value={todosComerciaisDefinition}
                onChange={onChangeTodosComerciaisHandler}
              >
                <div style={{ width: '100%' }}>
                  <RadioField
                    label="Todos os Comerciais"
                    value="0"
                    style={{ marginTop: '0px' }}
                  />
                </div>
                <div style={{ width: '100%', display: 'flex' }}>
                  <RadioField label="Comercial:" value="1" style={{ marginTop: '0px' }} />
                  <SelectorField
                    style={{ width: '300px' }}
                    isForm
                    hasEmptyLabel
                    disabled={comercialEspecifico !== true}
                    items={usuariosComerciais}
                    name="idUsuarioComercial"
                    value={idUsuarioComercial}
                    onChange={(e) => {
                      setIdUsuarioComercial(e.target.value);
                    }}
                  />
                </div>
              </GroupDefinitions>
            </div>

            <div style={{
              border: '1px solid', padding: '10px', marginLeft: '10px', width: '28%', alignContent: 'center',
            }}
            >
              <WrapperSubTitleForm title="Status dos Clientes:">
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <div style={{ padding: '10px', width: '70%' }}>
                    <GroupDefinitions
                      aria-label="statusCliente"
                      value={statusClienteDefinition}
                      onChange={e => setStatusClienteDefinition(e.target.value)}
                    >
                      <div style={{ width: '100%' }}>
                        <RadioField
                          label="Só Ativos"
                          value="A"
                          style={{ marginTop: '0px' }}
                        />
                      </div>
                      <div style={{ width: '100%', display: 'flex' }}>
                        <RadioField
                          label="Só Inativos"
                          value="I"
                          style={{ marginTop: '0px' }}
                        />
                      </div>
                      <div style={{ width: '100%', display: 'flex' }}>
                        <RadioField
                          label="Todos"
                          value="T"
                          style={{ marginTop: '0px' }}
                        />
                      </div>
                    </GroupDefinitions>
                  </div>
                </div>
              </WrapperSubTitleForm>
            </div>

            <div style={{
              border: '1px solid', padding: '10px', marginLeft: '10px', width: '20%', alignContent: 'center',
            }}
            >
              <MoneyField
                isForm
                style={{ width: '150px' }}
                maxlength={16}
                label="Débitos acima de"
                name="debitosAcimaDe"
                value={debitosAcimaDe}
                onChange={(e) => { setDebitosAcimaDe(e.target.value); }}
              />
            </div>
          </div>
          <div style={{ marginTop: '10px' }}>
            <div className={styles.checkboxContainer}>
              <div>
                <CheckboxField
                  label="Selecionar dados dos dois sistemas"
                  name="selecionarDosDoisSistemas"
                  checked={selecionarDosDoisSistemas}
                  onChange={e => setSelecionarDosDoisSistemas(e.target.checked)}
                />
              </div>
              <div>
                <Dica mensagemDica="Utilizar dados do sistema ABE e do sistema ABE Web para geração do relatório." />
              </div>
            </div>
          </div>
          <div style={{ display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
            <div>
              <ClearButton
                style={{ width: '150px' }}
                onClick={() => { onLimparHandler(); }}
                iconFontAwesome="fas fa-eraser"
                label="Limpar"
              />
              <SearchButtonWithLabel
                style={{ width: '150px', marginLeft: '10px' }}
                label="Pesquisar"
                type="button"
                onClick={() => { onSubmitHandler(); }}
              />
            </div>
          </div>
        </WrapperSubTitleForm>
      </div>
      <div style={{
        border: '1px solid', padding: '10px', width: '100%', marginTop: '10px',
      }}
      >
        <WrapperSubTitleForm title="Exportar">
          <div style={{ marginTop: '10px' }}>
            <ButtonUI
              style={{ width: '100px' }}
              color="white"
              disabled={content.length === 0}
              onClick={() => { onClickExportarExcel(); }}
            >
              Excel
            </ButtonUI>
            <ButtonUI
              style={{ width: '100px', marginLeft: '10px' }}
              color="white"
              disabled={content.length === 0}
              onClick={() => { onClickExportarPDF(); }}
            >
              PDF
            </ButtonUI>
          </div>
          <TitleTable>
            Relação de Clientes
          </TitleTable>
          <TabelaClientesEmDebito
            content={content}
          />
        </WrapperSubTitleForm>
      </div>
    </ContainerPrincipal>
  );
}

export const ClientesEmDebito = withRouter(ClientesEmDebitoComponent);
